import { useContext, useEffect, useState } from 'react';
import { convertFromCents, formatNumber } from '@/utils/amountUtils';
import { useTranslations } from 'next-intl';
import { CurrencyContext } from '@/contexts/CurrencyProvider';

export default function usePoints(config, userPoints, pointsToRedeem, order) {
  const [pointsTitle, setPointsTitle] = useState();
  const [pointsSubtitle, setPointsSubtitle] = useState();
  const [pointsSteps, setPointsSteps] = useState();
  const [canRedeem, setCanRedeem] = useState(false);
  const [showPoints, setShowPoints] = useState(true);
  const { formatter } = useContext(CurrencyContext);
  const t = useTranslations('checkout.points');

  useEffect(() => {
    setPointsTitle(t('title', { points: userPoints }));

    const pointsRedeptionItem =
      config?.order?.checkout?.paymentOptions?.find(option => option.type === 'POINTS_REDEMPTION') ?? [];

    setShowPoints(pointsRedeptionItem.enabled && pointsRedeptionItem.visibleToUser);

    const newSteps =
      pointsRedeptionItem?.pointsRedemptionConfig?.steps?.length > 0
        ? pointsRedeptionItem?.pointsRedemptionConfig?.steps.map((step, index) => ({
            title: `-${formatter.format(convertFromCents(step.discountAmount))}`,
            subtitle: `${formatNumber(step.points)} ${t('points')}`,
            additionalText:
              userPoints < step.points ? `${formatNumber(step.points - userPoints)} ${t('missing_points')}` : '',
            selected: false,
            disabled: userPoints < step.points || order?.totalPrice < step.discountAmount,
            points: step.points,
            discountAmount: step.discountAmount,
          }))
        : [];

    setCanRedeem(newSteps.find(step => step.disabled === false) !== undefined);
    setPointsSteps(newSteps);
  }, [config, userPoints]);

  useEffect(() => {
    if (pointsSteps?.length > 0) {
      if (pointsToRedeem > 0) {
        const selectedPointsStep = pointsSteps.find(point => point.points === pointsToRedeem);
        if (selectedPointsStep) {
          setPointsSubtitle(
            t('selected_step_subtitle', {
              points: formatNumber(selectedPointsStep.points),
              money: formatter.format(convertFromCents(selectedPointsStep.discountAmount)),
            })
          );
          return;
        }
      }
      const availableSteps = pointsSteps?.filter(step => !step.disabled);
      if (availableSteps.length > 1) {
        setPointsSubtitle(t('subtitle'));
        return;
      }
      setPointsSubtitle(
        t('selected_step_subtitle', {
          points: formatNumber(pointsSteps[0].points),
          money: formatter.format(convertFromCents(pointsSteps[0].discountAmount)),
        })
      );
    }
  }, [pointsToRedeem, pointsSteps]);

  return { pointsTitle, pointsSubtitle, pointsSteps, setPointsSteps, canRedeem, showPoints };
}
